import { type TFunction } from 'i18next'
import * as R from 'remeda'

import { type TranslationSchema } from '~/locales/resources'
import {
  createBreadcrumbCreatorWithI18n,
  createLabeledPathCreatorWithI18n,
  createMatchedPathKeyHook,
  createPathCompiler,
  createPathParamsHook,
  createPathResolver,
} from '~/routes/utils'

export const rootPath = '/app-admin'

const pathRecord = {
  top: /*               */ '/',
  brandAccountsList: /* */ '/brand-accounts',
  coreMembersList: /*   */ '/core-members',
  usersDownload: /*         */ '/users-download',
  aiUsageExport: /*         */ '/ai-usage-export',
} as const

type PathRecord = typeof pathRecord
export type PathKey = keyof PathRecord
export type PathValue = ValueOf<PathRecord>
export type PathParams<Key extends PathKey> = AnalyzePathParams<PathRecord[Key]>

export const pathKeys = R.keys(pathRecord) as PathKey[]

export const pathLabelI18nKeyMap = {
  top: 'top',
  brandAccountsList: 'brand_account_list',
  coreMembersList: 'mforce_administrator_list',
  usersDownload: 'user_data_download',
  aiUsageExport: 'ai_usage_export',
} as const satisfies Record<PathKey, keyof TranslationSchema>

export const pathGroupLabelI18nKeyMap = {
  settings: 'settings',
} as const

export type PathGroupKey = keyof typeof pathGroupLabelI18nKeyMap

export const useMatchedPathKey = createMatchedPathKeyHook(pathRecord, rootPath)
export const usePathParams = createPathParamsHook(pathRecord)
export const compile = createPathCompiler(pathRecord, rootPath)
export const resolve = createPathResolver(pathRecord)

// eslint-disable-next-line jsdoc/require-param, jsdoc/require-returns
/**
 * TODO: [i18n改善] t関数を引数で受け取る設計を見直す
 * 翻訳キーを返し、呼び出し側でt()を適用する形に変更することで、保守性の改善を行う
 */
export const createLabeledPathWithI18n = (t: TFunction) =>
  createLabeledPathCreatorWithI18n(pathRecord, pathLabelI18nKeyMap, t, rootPath)

// eslint-disable-next-line jsdoc/require-param, jsdoc/require-returns
/**
 * TODO: [i18n改善] t関数を引数で受け取る設計を見直す
 * 翻訳キーを返し、呼び出し側でt()を適用する形に変更することで、保守性の改善を行う
 */
export const createBreadcrumbWithI18n = (t: TFunction) =>
  createBreadcrumbCreatorWithI18n(
    pathRecord,
    pathLabelI18nKeyMap,
    pathGroupLabelI18nKeyMap,
    t,
    rootPath,
  )
